export default {
    namespaced: true,
    state: () => ({
      show: false,
      text: '',
      color: 'success', // default
      timeout: 3000
    }),
    mutations: {
      showMessage(state, { text, color = 'success', timeout = 3000 }) {
        state.text = text
        state.color = color
        state.timeout = timeout
        state.show = true
      },
      hideMessage(state) {
        state.show = false
      }
    }
  }
  